import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[70vh] flex items-center justify-center px-5 py-16">
      <form onSubmit={submit} className="brutal-card w-full max-w-md p-8 bg-[#FFD01E]">
        <h1 className="font-display-black text-5xl mb-6">Admin Bon Sang</h1>
        <label className="block mb-3">
          <span className="text-xs uppercase font-bold tracking-widest">Email</span>
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full border-2 border-black rounded-xl px-4 py-3 bg-white focus:outline-none"
            required
          />
        </label>
        <label className="block mb-5">
          <span className="text-xs uppercase font-bold tracking-widest">Mot de passe</span>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full border-2 border-black rounded-xl px-4 py-3 bg-white focus:outline-none"
            required
          />
        </label>
        {err && (
          <p data-testid="login-error" className="text-sm text-[#FA6157] font-bold mb-4">
            {err}
          </p>
        )}
        <button
          data-testid="login-submit"
          type="submit"
          disabled={loading}
          className="brutal-btn brutal-btn-coral w-full justify-center"
        >
          {loading ? "Connexion…" : "Entrer"}
        </button>
      </form>
    </div>
  );
}
